import { useQueryClient } from '@tanstack/react-query';
import useMutationApi from '../useMutationApi';

export function useDeleteQuoteSheetLineItem({
  quoteSheetId,
  lineItemId,
}: {
  quoteSheetId: string;
  lineItemId: string;
}) {
  const queryClient = useQueryClient();
  return useMutationApi({
    endpoint: `accounts-payable/quote-sheets/${quoteSheetId}/line-items/${lineItemId}`,
    method: 'DELETE',
    options: {
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: [`accounts-payable/quote-sheets/${quoteSheetId}`],
        });
      },
    },
  });
}
